import { initCharts } from "../plugins/chart";
import { initTabs } from "../plugins/tabs";
import { initAccordions } from "../plugins/accordion";

export const initSuitabilityReport = () => {
  initCharts();
  initAccordions();
  initTabs();
};
